export class SendCompanyMachineMissingInfoEmailRequest {

    _id; // number,

    constructor(id) {
        this._id = id;
    }

    id() {
        return this._id;
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/machine/form/sendMissingInfoEmail/ws/SendCompanyMachineMissingInfoEmailRequest.js